import { useDownloadMutation } from '~/hooks/common';
import { axiosInstance, downloadBlobDataFile } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type { PostCollectingResultReportsDownloadParams } from '~/types/delivery-agency.types';

const fetchPostCollectingResultReportsDownload = async (
  params: PostCollectingResultReportsDownloadParams
): Promise<void> => {
  const response = await axiosInstance.post(
    API_ENDPOINT.DELIVERY_AGENCY.POST_COLLECTING_RESULT_REPORTS_EXCEL_DOWNLOAD,
    params,
    { responseType: 'blob' }
  );

  downloadBlobDataFile(response);
};

export const usePostCollectingResultReportsDownloadMutation = () => {
  return useDownloadMutation(fetchPostCollectingResultReportsDownload);
};
